import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { ReplaySubject, Observable } from 'rxjs';
import { LoaderService } from './loader.service';
import { finalize } from 'rxjs/operators';
import { environment } from '../environments/environment';

export class LoaderHttpInterceptor implements HttpInterceptor {
  private readonly pendingRequestsStatus: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public get pendingRequestsStatus$(): Observable<boolean> {
    return this.pendingRequestsStatus.asObservable();
  }
  constructor(private readonly loaderService: LoaderService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      ![
        environment.api.towns + '\\?q=',
        environment.api.communityAction + '\\?q=',
        environment.api.merge + '\\?q=',
        environment.addressesApi + '\\?q=',
      ].some((url: string) => !!req.url.match(url))
    ) {
      this.pendingRequestsStatus.next(true);
      this.loaderService.showLoader();
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.pendingRequestsStatus.next(false);
        this.loaderService.hideLoader();
      }),
    );
  }
}
